import { ProjectRenderer } from '../ProjectRenderer';
import { RenderUtils } from '../utils/RenderUtils';
import {
	MeshStandardMaterial,
	Vector2Tuple,
	Mesh,
	PlaneGeometry,
	GridHelper,
} from 'three';
import { ModulesGrid } from '../utils/ModulesGrid';
import RENDERER_CONFIG from '@/configs/rendererConfig';

const { PLANE } = RENDERER_CONFIG;

const DEFAULT_MATERIAL = new MeshStandardMaterial({
	color: 0xffffff,
});

export class ProjectPlane {
	static readonly LAYER = PLANE.LAYER;
	gridHelper: GridHelper | null = null;
	dimensions: Vector2Tuple = [PLANE.GRID.SIZE, PLANE.GRID.SIZE];
	plane: Mesh | null = null;

	constructor(private renderer: ProjectRenderer) {}

	createGrid() {
		this.gridHelper?.dispose();

		this.gridHelper = new GridHelper(
			PLANE.GRID.SIZE * ModulesGrid.GRID_UNIT * 2,
			PLANE.GRID.SIZE * 2,
			PLANE.GRID.COLOR,
			PLANE.GRID.COLOR
		);
		this.gridHelper.position.setY(PLANE.GRID.POS_Y);
		this.gridHelper.layers.set(ProjectPlane.LAYER);

		this.renderer.scene.add(this.gridHelper);
	}

	createPlane() {
		this.dispose();

		this.plane = new Mesh(
			new PlaneGeometry(this.dimensions[0], this.dimensions[1]),
			DEFAULT_MATERIAL.clone()
		);
		this.plane.rotateX(-(Math.PI / 2));
		this.plane.position.y = PLANE.POS_Y;

		this.renderer.scene.add(this.plane);

		this.createGrid();
	}

	private dispose() {
		if (!this.plane) return;
		this.gridHelper?.dispose();
		this.gridHelper = null;
		RenderUtils.disposeObject(this.plane);
	}
}
